export default __webpack_public_path__ + "static/AA081210_Citation_680-0141-03a_540x358-49c92024404800f6b9c6eeb999989f58.jpg";